import type { IEntityModel } from './base'
import type { IDigestParticipantItem } from './digest_participant_item'
import type { IParticipant } from './participant'
import type { IProject } from './project'
import type { IWorkspace } from './workspace'

export enum DigestParticipantType {
  Utc = 'utc',
  Participant = 'participant',
}

export interface IDigestParticipant extends IEntityModel {
  participantId: string
  projectId: string
  workspaceId: string
  day: string
  dayUnixTimestamp: number
  type: DigestParticipantType
  project?: IProject
  workspace?: IWorkspace
  participant: IParticipant
  digestParticipantItemList?: IDigestParticipantItem[]
}
